import React from "react";

import styles from '../Layout.module.css'
import gql from "graphql-tag";
import {useQuery} from "@apollo/react-hooks";

const GROUPS = gql`
  {
    groups {
      id
      accountID
      alias
      roleName
    }
  }
`

const HomePage = (props) => {
  const {loading, error, data} = useQuery(GROUPS);

  if (loading) {
    // intentionally left blank
  } else if (error) {
    return <div>{error}</div>
  }

  const groups = []
  if (data && data.groups) {
    for (let i in data.groups) {
      const group = data.groups[i];
      groups.push(<a key={group.id} className={styles.card} href={`/aws/${group.accountID}/${group.roleName}`}>
        <div className={styles.p1}>
          <div className={styles.mustRow}>
            <div className={styles.awsLogo}/>
            <div className={styles.link}>
              <p className={styles.h2}>{group.alias}</p>
              <p style={{fontSize: 'smaller'}}>{group.accountID}</p>
            </div>
          </div>
          <h3>{group.roleName}</h3>
        </div>
      </a>)
    }
  }

  return <div>
    <div className={styles.t2}/>
    <div className={styles.container}>
      <h2>Realogy Datalake</h2>
      <p>Click on the card to download credentials:</p>
      <div className={styles.cards}>
        {groups}
      </div>
    </div>
  </div>;
}

export default HomePage;
